import script from "./SnackbarLimitInvoice.vue?vue&type=script&setup=true&lang=ts"
export * from "./SnackbarLimitInvoice.vue?vue&type=script&setup=true&lang=ts"

import "./SnackbarLimitInvoice.vue?vue&type=style&index=0&id=be186d18&lang=css"

const __exports__ = script;

export default __exports__